import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as fromRootStore from "../../reducers";
import { CommonService } from "../../services/common.service";
import {
  ExcelService,

  ReportService
} from "../../services/index";
declare var google;

@Component({
  selector: "agentStockReport",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./agentStockReport.html",
  // changeDetection:ChangeDetectionStrategy.OnPush,
})
export class agentStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  designnoList = [];
  dataList = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  fitList = [];
  styleList = [];
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter: any = {
    type1: "",
    aoid : '',
    brand: "",
    style: "",
    fit: "",
    design_no: "",
    barcode : "",
    stock_type: "",
    type: "",
    party_id: "",
    groupby: "overAllStock",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;
  columns = [];
  totalList = {
    ftot: 0,
    htot: 0,
    tot: 0,
  };
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  stockList = [];
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private reportService: ReportService,
    public toasterService: ToasterService,
    private change: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.stockReport();
    this.brandlist();
  }

  stockReport() {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    this.reportService.getAgentStock(params).then(function (res: any) {
      that.stockList = res.data;
      that.stockList.forEach((el) => {
        that.totalList.ftot += Number(el.ftot);
        that.totalList.htot += Number(el.htot);
        that.totalList.tot += Number(el.tot);
      });

      that.stockList[0].background = "lightcyan";
      that.stockList[1].background = "bisque";
      that.stockList[2].background = "lightblue";
      that.stockList[3].background = "lightgoldenrodyellow";

      that.change.detectChanges();
    });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    this.styleList = data.style;
    this.fitList = data.fit;
    let style = data.style;
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  nextLevel(params) {
    let stock_type = params.type;

    if(this.filter.groupby == 'stockType'){
      this.filter.groupby = 'stockBarcodeType';
      this.filter.aoid = params.row.aoid;
    }

    if(this.filter.groupby == 'overAllStock'){
        this.filter.groupby = 'stockType';
        this.filter.stock_type = stock_type;
    }

    this.getReport();
  }

  onbackbutton() {
    // if(this.filter.groupby=='coreNewWise' || this.filter.groupby=="estimateCoreNew" || this.filter.groupby=='damageCoreNew' || this.filter.groupby=="textileDesign" || this.filter.groupby=="befAcDesign" || this.filter.groupby=="aftAcDesign"){
    //     this.filter.groupby = 'overAllStock';
    // }
    this.filter.groupby = "overAllStock";
    this.filter.stock_type = "";
    this.filter.party_id = "";
    this.filter.design_no = "";
    this.filter.barcode = "";
    this.filter.invoiceno = "";
    this.filter.type = "";
    this.getReport();
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  onCellClick(event) {
    this.filter.design_no = event.row.design_no;
    if (this.filter.groupby == "overAllStock") {
      this.filter.groupby = "overAllStock";
    }
    this.getReport();
  }

  // applyFilter(): void {
  //   this.filter.party_id = "";
  //   this.filter.groupby = "overAllStock";
  //   this.filter.invoiceno = "";
  //   this.getReport();
  // }

  moneyFormat(nStr) {
    // if (nStr == null || nStr == undefined || nStr == '' || nStr == 0)
    //   return 0.00;
    // const no = parseFloat(nStr).toFixed(2);
    // /*if (no < 0) {
    //     nStr = no * -1;
    // }
    // nStr += '';*/

    // const x = no.split('.');
    // let x1 = x[0];
    // const x2 = x.length > 1 ? '.' + x[1] : '';
    // let rgx = /(\d+)(\d{3})/;
    // let z = 0;
    // const len = (x1).length;
    // const num = ((len / 2) - 1);
    // let newval = Math.floor(num);

    // while (rgx.test(x1)) {
    //   if (z > 0) {
    //     x1 = x1.replace(rgx, '$1' + ',' + '$2');
    //   } else {
    //     x1 = x1.replace(rgx, '$1' + ',' + '$2');
    //     rgx = /(\d+)(\d{2})/;
    //   }
    //   z++;
    //   newval--;
    //   if (newval == 0) {
    //     break;
    //   }
    // }

    // let out = x1 + x2;
    // if (Number(no) < 0) {
    //   out = '(' + out + ')';
    // }
    // return Number(out);

    var n1, n2;
    nStr = nStr + "" || "";
    // works for integer and floating as well
    n1 = nStr.split(".");
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    nStr = n2 ? n1 + "." + n2 : n1;
    return nStr;
  }
  getReport(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .nextLevelIOStock(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        // let menuObj = {
        //     cellClass: "txtCenter",
        //     name: "PCS%",
        //     prop: "percent",

        //     width: "90"
        //    }
        //    let menuObj1 = {
        //     cellClass: "txtCenter",
        //     name: "VAL%",
        //     prop: "percent1",

        //     width: "90"
        //    }
        //    that.gridOptions.columns.push(menuObj);
        //    that.gridOptions.columns.push(menuObj1);
        //    let arrVal =res.data;
        //    let totalCnt = 0;
        //    let totalCnt1 = 0;

        //    for(var j =0;j<arrVal.length;j++){
        //        let temp = arrVal[j];
        //    totalCnt += parseFloat(temp.tot);
        //    totalCnt1 += parseFloat(temp.totval);
        //    }
        //    for(var k =0;k<arrVal.length;k++){
        //     let temp1 = arrVal[k];
        //   let  percent:any;
        //   let  percent1:any;
        //   percent =((temp1.tot/totalCnt)*100).toFixed(2);
        // res.data[k].percent = percent;
        // percent1 =((temp1.totval/totalCnt1)*100).toFixed(2);
        // res.data[k].percent1 = percent1;
        // }
        that.exceldata = that.getData(res.columns, res.data);
        that.change.detectChanges();
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }

  clearFilter(): void {
    //  this.filter.party_code= "";
    this.filter.barcode = "";
    this.filter.design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    if(this.filter.groupby=='overAllStock'){
      this.stockReport();
    }else{
      this.getReport();
    }
    
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/agentStockReport.ts